/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 *
 * @author Satyaki Bose
 * @file settingsSelectSharedStyles.js
 */

import mixins from '../../../../assets/styles/mixins.scss';

export default function getSettingsSelectShellStyles() {
  return {
    selectRoot: {
      height: 48,
      borderRadius: 4,
      backgroundColor: mixins.chalkWhiteFont,
      fontFamily: mixins.fontFamilyPlusSans,
      fontSize: mixins.fontSize16,
      fontWeight: mixins.fontWeight600,
      lineHeight: '24px',
      color: mixins.timeIconColor,
      boxSizing: 'border-box',

      '& .MuiSelect-select': {
        display: 'flex',
        alignItems: 'center',
        padding: '12px',
        paddingRight: 32,
        boxSizing: 'border-box',
        height: 48,
        minHeight: 48
      },

      '&:hover': {
        backgroundColor: mixins.quaternary
      },

      '&:hover .MuiSelect-select': {
        backgroundColor: mixins.quaternary
      },

      '& .MuiSelect-select:focus': {
        backgroundColor: mixins.chalkWhiteFont
      },

      '& .MuiSelect-icon': {
        top: 'calc(50% - 11px)'
      },

      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: mixins.amethystColorV2
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: mixins.amethystColorV2
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: mixins.amethystColorV2,
        borderWidth: 1
      }
    },
    selectDisabled: {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: mixins.disabledInputBoxColor
      }
    },
    menuPaper: {
      '& .MuiMenuItem-root': {
        '&:hover': {
          backgroundColor: mixins.quaternary
        },
        '&.Mui-selected': {
          backgroundColor: `${mixins.quaternary} !important`
        },
        '&.Mui-selected:hover': {
          backgroundColor: `${mixins.quaternary} !important`
        }
      }
    },
    menuItem: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      fontFamily: mixins.fontFamilyPlusSans,
      fontSize: mixins.fontSize16,
      fontWeight: mixins.fontWeight400,
      lineHeight: '24px',
      color: mixins.timeIconColor,

      '&:hover': {
        backgroundColor: mixins.quaternary
      },
      '&.Mui-selected': {
        backgroundColor: `${mixins.quaternary} !important`
      },
      '&.Mui-selected:hover': {
        backgroundColor: `${mixins.quaternary} !important`
      }
    },
    menuItemSelected: {
      fontWeight: mixins.fontWeight600
    },
    menuItemLabel: {
      flex: '1 1 auto',
      minWidth: 0,
      pointerEvents: 'none'
    },
    menuItemCheckIcon: {
      width: 18,
      height: 18,
      fontSize: 18,
      marginLeft: 8,
      flexShrink: 0,
      display: 'block',
      color: mixins.timeIconColor,
      pointerEvents: 'none'
    },
    menuItemCheckIconPlaceholder: {
      visibility: 'hidden'
    }
  };
}
